/**
 *  @class
 *  @function RemoveAll
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.debouncedOnSubmit = debounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    onSubmitHandler() {
  this.classList.add('loading');

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
    // No body required
  })
  .then(response => {
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json(); // returns the cleared cart
  })
  .then(data => {
    // Cart is now empty – refresh the drawer
    if (this.drawer && typeof this.drawer.refresh === 'function') {
      this.drawer.refresh();
    } else {
      console.warn('drawer.refresh not found – reloading page instead');
      location.reload();
    }
  })
  .catch(error => {
    console.error('Remove All failed:', error);
    // Optionally show user feedback (e.g., an alert)
  })
  .finally(() => {
    this.classList.remove('loading');
  });
}
  }
  customElements.define('remove-all', RemoveAll);
}